module.exports = __webpack_public_path__ + "img/signature.a6668b80.svg";